// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/formation-flight.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/formation-flight/formation-flight.js';

mount([g0]);
